import { TransformedQuery } from './transformed-query';
import { AbstractQueryTransformer } from './abstract-query-transformer';

/**
 * normalize a format statement like 10x15 or 10*15 to "10 x 15" with quotes for single word search.
 */
export class FormatQueryTransformer extends AbstractQueryTransformer {
  pattern: RegExp = /(.+\s)?([0-9]{1,3})\s*[x*]\s*([0-9]{1,3})(\s.+)?/i;

  /**
   * build a new query with quoted and normalized format string.
   * @param queryParts
   */
  getTransformedQueryByParts(queryParts: RegExpMatchArray): TransformedQuery {
    const newTransformedParts = [];

    if (queryParts[1]) {
      if (this.pattern.test(queryParts[1])) {
        newTransformedParts.push(this.getTransformedQueryByParts(queryParts[1].trim().match(this.pattern)));
      } else {
        newTransformedParts.push(new TransformedQuery(queryParts[1].trim()));
      }
    }

    if (queryParts[2] && queryParts[3]) {
      newTransformedParts.push(new TransformedQuery(`"${queryParts[2].trim()} x ${queryParts[3].trim()}"`, true));
      newTransformedParts.push(new TransformedQuery(`"${queryParts[3].trim()} x ${queryParts[2].trim()}"`, true));
    }

    if (queryParts[4]) {
      if (this.pattern.test(queryParts[4])) {
        newTransformedParts.push(this.getTransformedQueryByParts(queryParts[4].trim().match(this.pattern)));
      } else {
        newTransformedParts.push(new TransformedQuery(queryParts[4].trim()));
      }
    }

    return new TransformedQuery(newTransformedParts);
  }
}
